import React, { useEffect } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { TransformationSection } from './components/TransformationSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ProductPreview } from './components/ProductPreview';
import { ValueStack } from './components/ValueStack';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-slate selection:bg-brand-amber selection:text-white" data-id="element-0">
      <StickyTopBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <TransformationSection data-id="element-5" />
        <BenefitsGrid data-id="element-6" />
        <ProductBreakdown data-id="element-7" />
        <ProductPreview data-id="element-8" />
        <ValueStack data-id="element-9" />
        <OfferSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}